import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectAllProductsInBasket } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/selector';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'sumOfProductsInBasketOfTheSelectedPhoto',
    standalone: false
})
export class SumOfProductsInBasketOfTheSelectedPhotoPipe
  implements PipeTransform
{
  constructor(private store: Store) {}

  transform(photoId: string): Observable<number> {
    return this.store.pipe(select(selectAllProductsInBasket)).pipe(
      map((allProductsInBasket) => {
        let sumProduct = 0;
        allProductsInBasket.forEach((value) => {
          switch (
            value.file ||
            value.product ||
            value.print ||
            value.package ||
            value.calendar
          ) {
            case value.file:
              if (value.file?.photoId === photoId) {
                sumProduct += 1;
              }
              break;
            case value.product:
              if (
                value.product.photoIdList.find((p) => p.photoId === photoId)
              ) {
                sumProduct += value.product.quantity;
              }
              break;
            case value.print:
              if (value.print.photoId === photoId) {
                sumProduct += value.print.count;
              }
              break;
            case value.calendar:
              if (value.calendar.photoId === photoId) {
                sumProduct += value.calendar.count;
              }

              break;
            case value.package:
              value.package.file.forEach((file) => {
                if (file.photoId === photoId) {
                  sumProduct += 1;
                }
              });
              value.package.print.forEach((print) => {
                if (print.photoId === photoId) {
                  sumProduct += print.count;
                }
              });
              value.package.product.forEach((product) => {
                if (product.photos.find((p) => p.photoId === photoId)) {
                  sumProduct += product.count;
                }
              });
              break;
          }
        });
        return sumProduct;
      }),
    );
  }
}
